import { Button } from "primereact/button";
import classes from "../../RuleWizard/RuleWizard.module.css";

// Shared layout pieces for the AiBox setup wizard steps - styled with the RuleWizard
// stylesheet so both wizards look the same.

export const StepHeader = ({ title, subtitle }) => (
    <div className={classes.contentHeader}>
        <h2 className={classes.contentTitle}>{title}</h2>
        {subtitle && <p className={classes.contentSubtitle}>{subtitle}</p>}
    </div>
);

export const StepBody = ({ children, style }) => (
    <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px", minHeight: 0, ...style }}>
        {children}
    </div>
);

export const StepNav = ({ onBack, onClose, onNext, nextLabel = "Next", nextIcon = "pi pi-arrow-right", nextDisabled, nextLoading }) => (
    <div className={classes.navRow}>
        {onBack || onClose
            ? (
                <div style={{ display: "flex", gap: "8px" }}>
                    {onBack && <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />}
                    {onClose && <Button label="Close" icon="pi pi-times" severity="secondary" outlined onClick={onClose} />}
                </div>
            )
            : <span />}
        {onNext && (
            <Button
                label={nextLabel}
                icon={nextIcon}
                iconPos="right"
                severity="success"
                disabled={nextDisabled}
                loading={nextLoading}
                onClick={onNext}
            />
        )}
    </div>
);

export const SectionHeader = ({ label }) => (
    <p style={{ margin: "12px 0 4px", fontSize: "11px", fontWeight: 600, color: "var(--text-label)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
        {label}
    </p>
);

// Selectable card - square tick for multi-select, round dot for single-select (radio).
export const OptionCard = ({ title, subtitle, selected, onClick, radio, disabled, right, top }) => (
    <div
        onClick={disabled ? undefined : onClick}
        style={{
            display: "flex", alignItems: "center", gap: "14px",
            padding: "12px 16px",
            border: `2px solid ${selected ? "var(--Primary-Color)" : "#e0e0e0"}`,
            borderRadius: "8px",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
            transition: "border-color 0.15s ease",
        }}
    >
        <div style={{
            width: "18px", height: "18px", borderRadius: radio ? "50%" : "4px", flexShrink: 0,
            border: `2px solid ${selected ? "var(--Primary-Color)" : "#ccc"}`,
            background: selected && !radio ? "var(--Primary-Color)" : "white",
            display: "flex", alignItems: "center", justifyContent: "center",
        }}>
            {selected && (radio
                ? <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "var(--Primary-Color)" }} />
                : <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>)}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
            {top}
            <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>{title}</p>
            {subtitle && <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e", wordBreak: "break-word" }}>{subtitle}</p>}
        </div>
        {right}
    </div>
);
